import * as React from 'react';
import { cn } from '@shared/utils/cn';
import { icons as lucideIcons } from 'lucide-react';

function isUrlLike(s: string) {
  return /^(https?:|data:|\/|\.\/|\.\.\/)/.test(s);
}

function normalizeLucideName(raw: string): string {
  let s = String(raw || '').trim();
  s = s.replace(/^lucide[:\/-]/i, '');
  s = s.replace(/icon$/i, '');
  s = s.replace(/[\s_]+/g, '-');
  s = s.replace(/\.(svg|png|jpg|jpeg|gif|webp)$/i, '');
  s = s.replace(/[^a-z0-9-]/gi, '');
  if (!s) return '';
  const parts = s.split('-').filter(Boolean);
  const pascal = parts
    .map((p) => {
      if (/^[A-Z0-9]+$/.test(p)) return p;
      if (/^[a-zA-Z]$/.test(p)) return p.toUpperCase();
      if (/^[0-9]+[a-z]$/i.test(p)) return p[0] + p.slice(1).toLowerCase();
      return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    })
    .join('');
  return pascal;
}

export function PaletteIcon({ icon, className }: { icon?: string; className?: string }) {
  if (!icon) return null;
  const str = String(icon).trim();
  if (!str) return null;
  if (isUrlLike(str)) {
    return (
      <img
        src={str}
        alt=""
        aria-hidden
        className={cn('size-4 rounded-sm object-contain opacity-70', className)}
      />
    );
  }
  const name = normalizeLucideName(str);
  const Lucide = (lucideIcons as any)[name] as React.ComponentType<any> | undefined;
  if (Lucide) {
    return <Lucide className={cn('size-4 text-muted-foreground', className)} aria-hidden />;
  }
  return null;
}

export default PaletteIcon;

